import AlbumSlideshowView from './AlbumSlideshowView';

export default AlbumSlideshowView;
